import OrderOptimizerListingRouteQueryParams from "../../../common/routes/types/order-optimizer-listing-route-params";
import OrderOptimizerCargoListingFilter, {
  OrderOptimizerCargoListingOrderHumanIdFilter,
} from "../common/types/order-optimizer-cargo-listing-filter";
import OrderOptimizerCargoListingFilterType from "../common/types/order-optimizer-cargo-listing-filter-type";

const getPage = (
  routeQueryFilterParams: OrderOptimizerListingRouteQueryParams
): number | undefined => {
  return routeQueryFilterParams.page
    ? Number(routeQueryFilterParams.page)
    : undefined;
};

const getPageSize = (
  routeQueryFilterParams: OrderOptimizerListingRouteQueryParams
): number | undefined => {
  return routeQueryFilterParams.pageSize
    ? Number(routeQueryFilterParams.pageSize)
    : undefined;
};

const getFilters = (
  routeQueryFilterParams: OrderOptimizerListingRouteQueryParams
): OrderOptimizerCargoListingFilter[] => {
  const filters: OrderOptimizerCargoListingFilter[] = [];

  if (routeQueryFilterParams.orderHumanId) {
    const orderHumanIdFilter: OrderOptimizerCargoListingOrderHumanIdFilter = {
      type: OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID,
      value: Number(routeQueryFilterParams.orderHumanId),
    };

    filters.push(orderHumanIdFilter);
  }

  return filters;
};

const createRouteQueryParams = (
  filters: OrderOptimizerCargoListingFilter[],
  page: number,
  pageSize: number
): OrderOptimizerListingRouteQueryParams => {
  const orderHumanId = filters.find(
    (filter) =>
      filter.type === OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID
  )?.value as OrderOptimizerCargoListingOrderHumanIdFilter["value"] | undefined;

  const routeQueryParams: OrderOptimizerListingRouteQueryParams = {
    page: page ? page.toString() : undefined,
    pageSize: pageSize ? pageSize.toString() : undefined,
    orderHumanId: orderHumanId ? orderHumanId.toString() : undefined,
  };

  return routeQueryParams;
};

const orderOptimizerCargoListingFiltersService = {
  getPage,
  getPageSize,
  getFilters,
  createRouteQueryParams,
};

export default orderOptimizerCargoListingFiltersService;
